/*
 * @Description: 项目日常检查
 * @Autor: pangting
 * @Date: 2026-09-24 14:07:00
 * @LastEditors: pangting
 * @LastEditTime: 2026-09-24 14:10:03
 */
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class WorkProjectcheckApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'work-projectcheck'
  }



}
